export default "__VITE_ASSET__8add3c45__"